import { AdminMainLoader } from './AdminMainLoader';
import { AdminMainTabs } from './bereiche/AdminMainTabs';
import { IDs } from '../helpers/IDs';
import { lazyInject } from '../services/inversify';
import * as React from 'react';
import style from './main.less';
import { TriggerService } from '../core/trigger/trigger_service';
import { WSpinner } from '../core/elements/spinner/WSpinner';

interface AdminMainContentProps extends React.ClassAttributes<any> {
    onRoutingChange: (routing: any) => void;
    routing: any;
    lang?: string;
}

interface AdminMainContentState extends React.ClassAttributes<any> {
    data: any;
    showSpinner: boolean;
    standorte: Array<any>;
    standortSelected: any;
}

export class AdminMainContent extends React.Component<AdminMainContentProps, AdminMainContentState> {
    constructor(props: any) {
        super(props);
        this.state = {
            data: undefined,
            showSpinner: false,
            standorte: undefined,
            standortSelected: undefined
        };
        this.onDataLoaded = this.onDataLoaded.bind(this);
        this.reloadData = this.reloadData.bind(this);
    }

    private loader: AdminMainLoader;

    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidMount(): void {
        this.load();
        this.triggerService.register('admin_reload', IDs.ENT_STANDORT, this.reloadData);
    }

    componentDidUpdate(prevProps: Readonly<AdminMainContentProps>, prevState: Readonly<AdminMainContentState>, snapshot?: any): void {
        // Bitte verwenden LANGUAGE_SELECTED, die Sprachauswahl an Komponenten zu übergeben, um dort ein Update auszulösen.
        if (this.state.data && this.props.lang !== prevProps.lang) {
            const data = this.state.data;
            data.LANGUAGE_SELECTED = this.props.lang;
            this.setState({ data });
        }
    }

    load(): void {
        this.setState({ showSpinner: true }, () => {
            this.loader = new AdminMainLoader(this.onDataLoaded);
            this.loader.loadData();
        });
    }

    onDataLoaded(data: any): void {
        console.log('Data Loaded:', data);
        this.setState({
            data: data,
            standorte: data[IDs.ENT_STANDORT],
            showSpinner: false
        });
    }

    reloadData(): void {
        this.load();
    }

    render(): JSX.Element {
        if (!this.state.data) {
            return <WSpinner />; // showspinner ist dann eigentlich obsolete
        }
        return (
            <div className={style.mainContentBox}>
                <AdminMainTabs
                    data={this.state.data}
                    onRoutingChange={this.props.onRoutingChange}
                    routing={this.props.routing}
                    standortSelected={this.state.standortSelected}
                />
            </div>
        );
    }
}
